export default "__VITE_ASSET__DsROO58b__"